import { useCallback } from 'react';
import get from 'lodash/get';
import gql from 'graphql-tag';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/react-hooks';
import { useIntl } from 'react-intl';
import useUser from 'hooks/user/useUser';
import { formatGraphqlErrors } from 'utils/helpers';

export const SEND_VERIFICATION_EMAIL_MUTATION = gql`
  mutation resendVerificationEmail($email: String) {
    resendVerificationEmail(email: $email) {
      success
    }
  }
`;

const useSendVerificationEmail = () => {
  const { formatMessage: __ } = useIntl();
  const [me] = useUser();
  const email = get(me, 'emails[0].address', null);
  const [sendVerificationAccountEmail, { loading }] = useMutation(SEND_VERIFICATION_EMAIL_MUTATION, {
    onCompleted: () => {
      toast.success(__({ id: 'verify_account.email_sent' }));
    },
    onError: (e) => toast.error(formatGraphqlErrors(e).message),
  });

  const handleSendVerificationEmail = useCallback(async () => {
    try {
      await sendVerificationAccountEmail({ variables: { email } });
    } catch (error) {
      toast.error(formatGraphqlErrors(error).message);
    }
  }, [email, sendVerificationAccountEmail]);

  return [handleSendVerificationEmail, loading];
};

export default useSendVerificationEmail;
